import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

const dynamicFontSize = css`
  font-size: 1.2rem;
  font-size: clamp(
    1.2rem,
    1.1090909090909091rem + 0.36363636363636354vw,
    1.4rem
  );
`

const Wrap = styled.div`
  padding-bottom: 2rem;
  padding-top: 2rem;
  a {
    ${dynamicFontSize}
    font-family: 'Futura', sans-serif;
    display: inline;
  }
`

const Excerpt = styled.span`
  ${dynamicFontSize}
  font-family: 'Futura', sans-serif;
`

const PostExcerpt = ({ excerpt, to, withLink = false }) => {
  if (!excerpt) return null
  const excerptWithoutPTag = excerpt.replace(/<p>/g, '').replace(/<\/p>/g, '')
  const trimmedExcerpt = excerptWithoutPTag.substring(0, 140)
  return (
    <Wrap>
      {withLink ? (
        <Excerpt dangerouslySetInnerHTML={{ __html: trimmedExcerpt }}></Excerpt>
      ) : (
        <Excerpt dangerouslySetInnerHTML={{ __html: excerpt }}></Excerpt>
      )}
      {withLink && <Link to={to}>... seguir leyendo</Link>}
    </Wrap>
  )
}

export default PostExcerpt
